










































































































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import * as api from '@/api';
import { debounce } from 'lodash';
import TimeInput from './sla/time-input.vue';
// import * as validators from '@/utils/validator';
import SatisfyNoticeReceiver from './satisfaction/satisfy-notice-component.vue';
import { TimeTypes } from '@/config/map.conf';

const oneHour: number = 60 * 60;
const CreateGroupSettingOptions = [
    {
        value: true,
        label: '开启'
    },
    {
        value: false,
        label: '关闭'
    }
];

const CommentsDeadlineMaxAndMin = {
    MINUTE: {
        min: 1,
        max: 4320
    },
    HOUR: {
        min: 1,
        max: 720
    },
    DAY: {
        min: 1,
        max: 365
    },
    WEEK: {
        min: 1,
        max: 4320
    }
};
/**
 * rg成员列表
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        TimeInput,
        SatisfyNoticeReceiver
    }
})
export default class RgSatisfaction extends Vue {
    @State(state => state.cti.permission.rg_satisfaction)
    permission: boolean;

    timeTypes: CommonTypes.mapObject = TimeTypes;
    commentsDeadlineMaxAndMin: CommonTypes.mapObject = CommentsDeadlineMaxAndMin;

    satisfySettingForm: CommonTypes.mapObject = {
        commentsRequire: true,
        commentsDeadlineRequire: false,
        commentsDeadlineInterval: 1,
        commentsDeadlineUnit: 'HOUR',
        maxPushNum: 1,
        intervalSecond: 1,
        uncommentMultiPush: true,
        dissatisfiedTtToCcEmps: {},
        dissatisfiedTtToPushEmps: {},
        dissatisfiedTtGroupJoinRequire: false,
        dissatisfiedReasonRequire: false,
        dissatisfiedReasons: [],
        commonTtToCcEmps: {},
        commonTtToPushEmps: {},
        commonTtGroupJoinRequire: true,
        commonReasonRequire: true,
        commonReasons: [],
        resolvedOptionDisplay: true,
        unresolvedTtToCcEmps: {}
    };
    settingOptions: CommonTypes.mapObject[] = CreateGroupSettingOptions;

    scoreInfo: any = {
        dissatisfied: {
            type: 'dissatisfied',
            ccList: [],
            pushList: [],
            reasonList: []
        },
        common: {
            type: 'common',
            ccList: [],
            pushList: [],
            reasonList: []
        }
    };

    switchChange: Function;

    created() {
        this.switchChange = debounce(this.setSatisfactionFunc, 500);
        this.getSatisfaction();
    }

    onReceiverChanged(val, key) {
        this.satisfySettingForm[key] = val;
        this.switchChange();
    }

    onDeadlineUnitChanged() {
        // 切换时间unit时，更新数值为最接近的合法值
        // 如果大于新unit的max，置为max；如果小于新unit的min，置为min
        const { commentsDeadlineInterval, commentsDeadlineUnit } = this.satisfySettingForm;
        const max = this.commentsDeadlineMaxAndMin[commentsDeadlineUnit]?.max;
        const min = this.commentsDeadlineMaxAndMin[commentsDeadlineUnit]?.min;
        if (commentsDeadlineInterval > max) {
            this.satisfySettingForm.commentsDeadlineInterval = max;
        } else if (commentsDeadlineInterval < min) {
            this.satisfySettingForm.commentsDeadlineInterval = min;
        }
        this.switchChange();
    }
    async getSatisfaction() {
        if (!Number(this.rgId)) {
            return;
        }
        const { code, data } = await api.ctiApi.getSatisfation({ rgId: Number(this.rgId) });
        if (code === 200) {
            const { rgId, id, createdBy, createdAt, updatedAt, updatedBy, ...rest } = data;
            this.satisfySettingForm = {
                ...rest,
                maxPushNum: data.maxPushNum || 1,
                intervalSecond: data.intervalSecond / oneHour || 1
            };
            this.scoreInfo.dissatisfied = {
                type: 'dissatisfied',
                ccList: this.satisfySettingForm.dissatisfiedTtToCcEmps || [],
                pushList: this.satisfySettingForm.dissatisfiedTtToPushEmps || [],
                reasonList: this.satisfySettingForm.dissatisfiedReasons || []
            };
            this.scoreInfo.common = {
                type: 'common',
                ccList: this.satisfySettingForm.commonTtToCcEmps || [],
                pushList: this.satisfySettingForm.commonTtToPushEmps || [],
                reasonList: this.satisfySettingForm.commonReasons || []
            };
        }
    }
    formatterIntervals(num) {
        return `${num}小时`;
    }
    parserIntervals(num) {
        return num.replace('小时', '');
    }
    /**
     * 当原因发生改变时的处理函数
     * @param {string} key - satisfySettingForm的键值
     * @param {string} operate - 操作类型，可以是 'add' 或 'delete'
     * @param {string|number} data - 数据，当 operate 为 'add' 时为新增的 reason，当 operate 为 'delete' 时为要删除的索引
     */
    onReasonChanged(key, operate: 'add' | 'delete', data) {
        if (operate === 'add') {
            this.satisfySettingForm[key].push(data);
        } else {
            this.satisfySettingForm[key].splice(data, 1);
        }
        this.switchChange();
    }
    async setSatisfactionFunc() {
        const { code, message } = await api.ctiApi.setSatisfaction({
            rgId: Number(this.rgId),
            ...this.satisfySettingForm,
            intervalSecond: this.satisfySettingForm.intervalSecond * oneHour
        });
        if (code === 200) {
            this.$mtd.message.success('保存成功');
            this.getSatisfaction();
        } else {
            this.$mtd.message.error(message);
        }
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    get maxTime() {
        return this.commentsDeadlineMaxAndMin[this.satisfySettingForm.commentsDeadlineUnit]?.max;
    }
    get minTime() {
        return this.commentsDeadlineMaxAndMin[this.satisfySettingForm.commentsDeadlineUnit]?.min;
    }

    addReason(type: string) {
        this.$mtd
            .confirm({
                title: `添加${type === 'dissatisfied' ? '不满意' : '一般'}原因`,
                message: '<input id="add-low-score-reason" class="mtd-input" style="width: 100%" />',
                dangerouslyUseHTMLString: true,
                onOk: async () => {
                    const inputElement = document.getElementById('add-low-score-reason') as HTMLInputElement;
                    const newReason = inputElement.value;
                    if (newReason.length) {
                        if (newReason.includes(',') || newReason.includes(';')) {
                            this.$mtd.message.error('原因中不能包含“, ;”等特殊字符，请重新输入');
                            return Promise.reject(new Error('原因中不能包含“, ;”等特殊字符，请重新输入'));
                        }
                        this.onReasonChanged(type + 'Reasons', 'add', newReason);
                    }
                }
            })
            .catch(e => e);
    }
    deleteReason(type: string, reason: string, index: number) {
        this.$mtd
            .confirm({
                title: `删除${type === 'dissatisfied' ? '不满意' : '一般'}原因`,
                message: `确定要删除${type === 'dissatisfied' ? '不满意' : '一般'}原因“${reason}”吗？`,
                type: 'warning',
                dangerouslyUseHTMLString: true,
                onOk: async () => {
                    this.onReasonChanged(type + 'Reasons', 'delete', index);
                }
            })
            .catch(e => e);
    }
}
